import bus from 'common/bus'

// 跨组件展示优先级注册表：记录当前正在展示的「营销悬浮框 / 弹窗」（按页面 index 标识）。
// 解决 MarketComponents(type65) 与 Popup(type102) 同页时的展示冲突：
//  - 即时触发的弹窗按页面排序让行靠前的悬浮框（hasEarlierShowing）
//  - 延迟触发的弹窗遇悬浮框在展示就不弹（hasAnyShowing，业务互斥）
const showing = new Map() // index -> type（'marketing' | 'popup'）

// 登记本组件已展示，并广播事件让排序靠后的组件主动隐藏让行
function registerShow(index, type) {
  showing.set(index, type)
  bus.$emit('comp-priority:shown', index)
}

// 注销（关闭 / 销毁时调用）
function unregisterShow(index) {
  showing.delete(index)
}

// 是否有 index 比我小的组件在展示——即时触发用，按页面排序让行靠前者
function hasEarlierShowing(myIndex) {
  return Array.from(showing.keys()).some((idx) => idx < myIndex)
}

// 是否有任意组件在展示——delay>0 用，业务互斥（悬浮窗在就不弹）
function hasAnyShowing() {
  return showing.size > 0
}

// 监听其他组件展示事件（靠后组件靠此判断是否要让行隐藏）
function onShown(cb) {
  bus.$on('comp-priority:shown', cb)
}

function offShown(cb) {
  bus.$off('comp-priority:shown', cb)
}

export default {
  registerShow,
  unregisterShow,
  hasEarlierShowing,
  hasAnyShowing,
  onShown,
  offShown,
}
